module.exports = __webpack_public_path__ + "img/Kelsey_Murphy.a0e753c5.png";